import { FreightPricingPortalError } from "@/types/error/FreightPricingPortalError";
import { SeparatorLine } from "@stenajs-webui/core";
import { CardBody } from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import * as React from "react";
import { useMemo, useState } from "react";
import { rebateAgreementDocumentsTableConfig } from "../config/RebateAgreementDocumentsTableConfig";
import { RebateAgreementDocumentsTableItem } from "../models";

interface Props {
  rebateDocuments: RebateAgreementDocumentsTableItem[] | undefined;
}

export const RebateAgreementDocumentsContent: React.FC<Props> = ({
  rebateDocuments,
}) => {
  const [downloadError, setDownloadError] =
    useState<FreightPricingPortalError>();
  const [deletedListItems, setDeletedListItems] = useState<Array<String>>([]);

  const config = useMemo(() => {
    return rebateAgreementDocumentsTableConfig(
      downloadError,
      setDownloadError,
      setDeletedListItems
    );
  }, [downloadError, setDownloadError, setDeletedListItems]);

  const items = rebateDocuments?.filter((d) => {
    return !deletedListItems.includes(d.id);
  });

  return (
    <CardBody>
      <StandardTable
        items={items}
        config={config}
        loading={false}
        noItemsLabel={"No documents found."}
      />
      <SeparatorLine />
    </CardBody>
  );
};
